import * as React from "react";
import type { SVGProps } from "react";
const SvgFilmperler = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104 104" {...props}>
    <path
      d="M3424 3015a52 52 0 1 1-52 52 52 52 0 0 1 52-52m23.71 77.39-4.72-4.73a12.8 12.8 0 0 1-2.78-4.14v3.83a7.42 7.42 0 0 1-7.39 7.4h-34.4a7.41 7.41 0 0 1-7.38-7.4v-18.5a7.41 7.41 0 0 1 7.38-7.4h34.4a7.42 7.42 0 0 1 7.39 7.4v4.41a12.8 12.8 0 0 1 2.78-4.14l4.72-4.73c5.09-5.1 9.25-3.38 9.25 3.84v20.32c0 7.22-4.16 8.94-9.25 3.84m-22.43-36.31a9.63 9.63 0 1 1 9.61-9.63 9.617 9.617 0 0 1-9.61 9.63m0-16.8a7 7 0 0 0-3 .67c.1-.01.2-.02.3-.02a8.736 8.736 0 0 1 8.72 8.73 8.4 8.4 0 0 1-.25 2.02 7.16 7.16 0 0 0-5.77-11.4m-20.65 16.8a9.63 9.63 0 1 1 9.61-9.63 9.617 9.617 0 0 1-9.61 9.63m0-16.8a7 7 0 0 0-3 .67 3 3 0 0 1 .31-.02 8.734 8.734 0 0 1 8.71 8.73 8.4 8.4 0 0 1-.25 2.02 7.16 7.16 0 0 0-5.77-11.4"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-3372 -3015)"
    />
  </svg>
);
export default SvgFilmperler;
